export enum PERMISSION {
    ALL = 1,
    READ_RMA = 2,
    WRITE_RMA = 3,
    READ_SETTINGS = 4,
    READ_BILLING_HISTORY = 6,
    READ_MANAGE_PLAN = 8,
    READ_ACCOUNT = 10,
    WRITE_ACCOUNT = 11,
    READ_REVENUE = 12,
    VIEW_HOME_PAGE = 13,
    VIEW_ANALYTICS_PAGE = 14,
    RESTOCK_RMA = 15,
    REFUND_RMA = 16,
    CHANGE_PASSWORD_TO_OTHER_USERS = 17,
    APPROVE_RMA_AS_MANAGER = 18,
    PROMPT_MANGER_APPROVAL = 19
}
